import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const formsRequest = createAction(types.FORMS_REQUEST);
export const formsSuccess = createAction(types.FORMS_SUCCESS);
export const formsFailure = createAction(types.FORMS_FAILURE);

export const formRequest = createAction(types.FORM_REQUEST);
export const formSuccess = createAction(types.FORM_SUCCESS);
export const formFailure = createAction(types.FORM_FAILURE);

export const createFormRequest = createAction(types.CREATE_FORM_REQUEST);
export const createFormSuccess = createAction(types.CREATE_FORM_SUCCESS);
export const createFormFailure = createAction(types.CREATE_FORM_FAILURE);

export const updateFormRequest = createAction(types.UPDATE_FORM_REQUEST);
export const updateFormSuccess = createAction(types.UPDATE_FORM_SUCCESS);
export const updateFormFailure = createAction(types.UPDATE_FORM_FAILURE);

export const editFormRequest = createAction(types.EDIT_FORM_REQUEST);
export const editFormSuccess = createAction(types.EDIT_FORM_SUCCESS);
export const editFormFailure = createAction(types.EDIT_FORM_FAILURE);

export const deleteFormRequest = createAction(types.DELETE_FORM_REQUEST);
export const deleteFormSuccess = createAction(types.DELETE_FORM_SUCCESS);
export const deleteFormFailure = createAction(types.DELETE_FORM_FAILURE);

export const importCRMFormsRequest = createAction(
  types.IMPORT_CRM_FORMS_REQUEST,
);
export const importCRMFormsSuccess = createAction(
  types.IMPORT_CRM_FORMS_SUCCESS,
);
export const importCRMFormsFailure = createAction(
  types.IMPORT_CRM_FORMS_FAILURE,
);

export const readFormsRequest = createAction(types.PRINTED_FORMS_REQUEST);
export const readFormsSuccess = createAction(types.PRINTED_FORMS_SUCCESS);
export const readFormsFailure = createAction(types.PRINTED_FORMS_FAILURE);

export const loadDealFormsRequest = createAction(types.LOAD_DEAL_FORMS_REQUEST);
export const loadDealFormsSuccess = createAction(types.LOAD_DEAL_FORMS_SUCCESS);
export const loadDealFormsFailure = createAction(types.LOAD_DEAL_FORMS_FAILURE);

export const resetForm = createAction(types.RESET_FORM);

export default {
  readFormsRequest,
  resetForm,
  formsRequest,
  formsSuccess,
  formsFailure,
  formRequest,
  formSuccess,
  formFailure,
  createFormRequest,
  createFormSuccess,
  createFormFailure,
  updateFormRequest,
  updateFormSuccess,
  updateFormFailure,
  editFormRequest,
  editFormSuccess,
  editFormFailure,
  deleteFormRequest,
  deleteFormSuccess,
  deleteFormFailure,
  importCRMFormsRequest,
  importCRMFormsSuccess,
  importCRMFormsFailure,
  loadDealFormsRequest,
  loadDealFormsSuccess,
  loadDealFormsFailure,
};
